/**
 * Pinch zoom on the timeline's lanes (epic 5.1).
 *
 * @module
 */
export interface Span {
  from: number;
  to: number;
}

const MIN_SPAN = 30_000;
const MAX_SPAN = 31 * 86_400_000;

/**
 * The range after two fingers moved from `a0`, `b0` to `a1`, `b1` (client x)
 * over a lane strip at `left` and `width`: the time between the fingers stays
 * under them, and their spread sets the zoom.
 */
export function pinched(
  start: Span,
  lane: { left: number; width: number },
  [a0, b0]: [number, number],
  [a1, b1]: [number, number],
): Span {
  const span0 = start.to - start.from;
  const at = (x: number) => start.from + ((x - lane.left) / lane.width) * span0;
  const before = Math.abs(b0 - a0);
  const after = Math.abs(b1 - a1);
  // Fingers almost together: pan only, or the zoom jumps.
  const span =
    before < 10 || after < 10
      ? span0
      : Math.min(Math.max((span0 * before) / after, MIN_SPAN), MAX_SPAN);
  const anchor = at((a0 + b0) / 2);
  const from = anchor - (((a1 + b1) / 2 - lane.left) / lane.width) * span;
  return { from, to: from + span };
}
